import { Map, fromJS } from 'immutable';

export function request(state, { sportId }) {
    return state
        .set('state', 'IN_PROGRESS')
        .setIn(['items', sportId], fromJS({}));
}

export function error(state, { sportId, errors }) {
    return state
        .set('state', 'ERROR')
        .setIn(['items', sportId, 'errors'], fromJS(errors));
}

export function finish(state, {sportId, prices}) {
    return state
        .set('state', 'FINISHED')
        .setIn(['items', sportId, 'prices'], fromJS(prices));
}
